export const deleteTagCategory = async (
    API_URL: string,
    token: string,
    employerId: string,
    categoryIdToDelete: string
) => {
    const response = await fetch(
        `${API_URL}/employers/${employerId}/tag-categories/${categoryIdToDelete}`,
        {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }
    );

    if (!response.ok)
        throw new Error(
          "There was a problem deleting this Tag Category. To delete a tag category, it must first not have any tags assigned to users."
        );
}